import { defineStore } from "pinia";
import { prepareParamsForFilterProducts } from '@/utils/api-drive-params'
import productListApiDrive from "@/services/http/api-drive/magasin/product-list";
import coraproUtils from "@/utils/corapro-code";

export const useProductsStore = defineStore({
  id: 'products',
  state: () => {
    return {
      categoryId: null,
      _filters: [],
      _appliedFilters: [],
      seoRedirect: false,
      isLoading: false,
      isLoadingInfinite: false,
      errorStatus: '',
      errorData: null,
      firstFilter: '',
      scrollMeaId: false,
      productsList: [],
      attributes: null,
      pagination: {},
      breadcrumbs: [],
      seoHead: null,
      filterVisible: false,
      showMoreClicked: false,
      showPreviousClicked: false,
      firstPageIndex: 1,
      lastPageIndex: 1,
      productsCount: 0,
      produitsDejaAchetes: [],
      contentType: "dp",
      sections: []
    }
  },
  actions: {
    productsFetched(response) {
      this.categoryId = response.categoryId;
      this.pagination = response.data.attributes.product_list !== null ? response.data.attributes.product_list.meta.pagination : {};
      this.attributes = response.data.attributes;
      const contentType = response.data.attributes.category.data.attributes.content_type || "dp";
      if (contentType !== this.contentType) {
        this.contentType = contentType;
      }
      if (this.showMoreClicked) {
        this.productsList = [...this.productsList, ...response.data.attributes.product_list.data]
        if (response.data.attributes.produits_deja_achetes) {
          this.produitsDejaAchetes = [...this.produitsDejaAchetes, ...response.data.attributes.produits_deja_achetes.data];
        }
        this.lastPageIndex += 1;
        this.productsCount = this.pagination.nb_items + ((this.pagination.current_page - 1) * this.pagination.per_page);
        this.showMoreClicked = false
        if (response.data.attributes.product_list) {
          this.sections.push({ page: this.pagination.current_page, products: response.data.attributes.product_list.data })
        }
      } else if (this.showPreviousClicked) {
        this.productsList = [...response.data.attributes.product_list.data, ...this.productsList]
        if (response.data.attributes.produits_deja_achetes) {
          this.produitsDejaAchetes = [...response.data.attributes.produits_deja_achetes.data, ...this.produitsDejaAchetes];
        }
        this.firstPageIndex -= 1;
        this.showPreviousClicked = false
        if (response.data.attributes.product_list) {
          this.sections.unshift({ page: this.pagination.current_page, products: response.data.attributes.product_list.data })
        }
      } else {
        this.productsList = response.data.attributes.product_list !== null ? response.data.attributes.product_list.data : [];
        this.produitsDejaAchetes = response.data.attributes.produits_deja_achetes !== null ? response.data.attributes.produits_deja_achetes.data : [];
        this.firstPageIndex = this.pagination.current_page
        this.lastPageIndex = this.pagination.current_page
        this.productsCount = this.pagination.nb_items + ((this.pagination.current_page - 1) * this.pagination.per_page);
        if (response.data.attributes.product_list) {
          this.sections = [{ page: this.pagination.current_page, products: response.data.attributes.product_list.data }]
        }
      }
      this.pagination.nb_items = this.productsCount;
      this._filters = response.data.attributes.product_list !== null ? response.data.attributes.product_list.meta.facettes : [];
      const filtersCoraProIndex = this._filters.findIndex((element) => element.code === coraproUtils.DP_SPARKOW_CORA_PRO_CODE);
      filtersCoraProIndex >= 0 && this._filters.splice(filtersCoraProIndex, 1);
      this._appliedFilters = response.data.attributes.product_list !== null ? response.data.attributes.product_list.meta.facettes_actives : []
      const appliedFiltersCoraProIndex = this._appliedFilters.findIndex((element) => element.code === coraproUtils.DP_SPARKOW_CORA_PRO_CODE);
      if (appliedFiltersCoraProIndex >= 0) { this._appliedFilters.splice(appliedFiltersCoraProIndex, 1); }
      this.breadcrumbs = response.meta ? response.meta.breadcrumb : [];
      this.seoHead = response.meta.head;
    },
    setSeoRedirect(value) {
      this.seoRedirect = value;
    },
    setShowMoreClicked(value) {
      this.showMoreClicked = value;
    },
    setShowPreviousClicked(value) {
      this.showPreviousClicked = value;
    },
    updateFilterVisible(value) {
      this.filterVisible = value;
    },
    updateLoadingStatus(value, infinite = false) {
      if (!value) {
        this.isLoadingInfinite = false;
        this.isLoading = false;
        return;
      }
      if (infinite) {
        this.isLoadingInfinite = value;
      } else {
        this.isLoading = value;
      }
    },
    setErrorStatus(err) {
      this.errorStatus = err.response ? err.response.status : 504;
    },
    setErrorData(err) {
      this.errorData = err.response ? err.response.data : {};
    },
    setFirstFilter(value) {
      this.firstFilter = value;
    },
    setScrollMeaId(value) {
      this.scrollMeaId = value;
    },
    resetStore() {
      this.categoryId = null;
      this.attributes = null;
      this.productsList = [];
      this.pagination = null;
      this.breadcrumbs = [];
      this._filters = [];
      this._appliedFilters = [];
      this.seoRedirect = false;
      this.showMoreClicked = false;
      this.showPreviousClicked = false;
      this.firstPageIndex = 1;
      this.lastPageIndex = 1;
      this.productsCount = 0;
      this.isLoadingInfinite = false;
      this.isLoading = false;
      this.errorStatus = '';
      this.errorData = null;
      this.seoHead = null;
      this.firstFilter = '';
      this.scrollMeaId = false;
      this.produitsDejaAchetes = [];
      this.sections = [];
    },
    async fetchProducts(params) {
      this.updateLoadingStatus(true);
      try {
        if (!params.isPro) {
          params.filterList = [{ code: coraproUtils.DP_SPARKOW_CORA_PRO_CODE, value: coraproUtils.DP_SPARKOW_CORA_PRO_STANDARD_VALUE }];
        }
        const response = await this.$apiDrive.use(productListApiDrive).products(params);
        this.productsFetched({ ...response.data, ...params });
        return Promise.resolve(response.data);
      } catch (err) {
        this.setErrorStatus(err);
        this.setErrorData(err);
        this.updateLoadingStatus(false);
        return Promise.reject(err);
      }
    },
    async fetchFiltredProductList(params) {
      this.updateLoadingStatus(true, this.showMoreClicked);
      try {
        if (!params.isPro) {
          const coraproFilter = { code: coraproUtils.DP_SPARKOW_CORA_PRO_CODE, value: coraproUtils.DP_SPARKOW_CORA_PRO_STANDARD_VALUE }
          if (params.filterList) {
            params.filterList.push(coraproFilter)
          } else {
            params.filterList = [coraproFilter]
          }
        }
        const response = await this.$apiDrive.use(productListApiDrive).productsFiltered(prepareParamsForFilterProducts(params));
        this.productsFetched({ ...response.data, ...params });
        return Promise.resolve(response.data);
      } catch (err) {
        this.setErrorStatus(err);
        this.setErrorData(err);
        return Promise.reject(err);
      } finally {
        this.updateLoadingStatus(false);
      }
    }
  },
  getters: {
    sortCriteria: (state) => {
      return state.attributes && state.attributes.product_list !== null ? state.attributes.product_list.meta.tri : []
    },
    hasAppliedSort: (state) => {
      return state.sortCriteria.some(sort => sort.defaut && !sort.actif);
    },
    filters: (state) => {
      if (state._filters && state.$config.public.HIDDEN_FILTERS_DP) {
        return state._filters.filter(f => {
          return !state.$config.public.HIDDEN_FILTERS_DP.includes(f.code)
        });
      }
      return state._filters;
    },
    description: (state) => {
      return state.attributes && state.attributes.description
    },
    alcool: (state) => {
      return state.attributes && state.attributes.alcool
    },
    appliedFilters: (state) => {
      if (state._appliedFilters && state.$config.public.HIDDEN_FILTERS_DP) {
        return state._appliedFilters.filter(f => {
          return !state.$config.public.HIDDEN_FILTERS_DP.includes(f.code)
        });
      }
      return state._appliedFilters;
    },
    hasOneAppliedFilter: (state) => {
      return state._appliedFilters.length <= 1;
    },
    title: (state) => {
      return state.attributes && state.attributes.title;
    },
    imageAmbiance: (state) => {
      return state.attributes && state.attributes.image_ambiance;
    },
    slug: (state) => {
      const slugObject = state.seoHead && state.seoHead.link ? state.seoHead.link.find(element => element.rel === "slug") : null
      return slugObject ? slugObject.href : null;
    },
    pimCategoryCode: (state) => {
      return state.attributes && state.attributes.pim_category_code;
    },
    category: (state) => {
      return state.attributes && state.attributes.category;
    },
    childrenCategories: (state) => {
      if (state.category) {
        if (state.category.data.attributes.children && state.category.data.attributes.children.data.length > 0) {
          return state.category.data.attributes.children.data;
        }
        if (state.category.data.attributes.siblings && state.category.data.attributes.siblings.data.length > 0) {
          // on ajoute manuellement l'item courant pour qu'il soit présent dans les siblings
          return [{ id: state.categoryId, attributes: { title: state.title, is_active: true } }, ...state.category.data.attributes.siblings.data];
        }
      }
      return [];
    },
    productsListMode: (state) => {
      return state.attributes && state.attributes.layout_type || "Grid";
    },
    hasPorteurDlc: (state) => {
      return state.attributes ? state.attributes.has_porteur_dlc : false;
    },
    pushZones: (state) => {
      return state.attributes ? state.attributes.push_zones : [];
    },
    pushProducts: (state) => {
      return state.category ? state.category.data.attributes.push_zones : [];
    },
    boiteLiens: (state) => {
      return state.attributes && state.attributes.boite_de_liens ? state.attributes.boite_de_liens : [];
    },
  }
})